(function (Drupal, $, once) {
  Drupal.behaviors.teamGrid = {
    attach: function (context) {
      once('team-card-ready', '.team-card', context).forEach(function (element) {
        var $this = $(element);
        var body = $this.children(".team-card__body");
        body.css("max-height", body.outerHeight() + "px"); //preserving height

        function toggleCard() {
          $this.find(".team-card__read-more").children().toggle();
          var bio = $this.find(".team-card__bio");
          var bioHeight = 0;
          bioHeight = bio.outerHeight(true);

          if ($this.hasClass("is-open")) {
            bio.stop().slideUp(300);
            $this.css("margin-bottom", "32px");
          } else if ($this.siblings(".is-open").length) {
            var openCard = $this.siblings(".is-open");
            openCard.find(".team-card__bio").stop().slideUp(300);
            openCard.removeClass("is-open");
            openCard.css("margin-bottom", "32px");
            openCard.find(".team-card__read-more").children().toggle();

            setTimeout(function () {
              bio.stop().slideDown(300);
              $this.css("margin-bottom", bioHeight + "px");
            }, 300);
          } else {
            bio.stop().slideDown(300);
            $this.css("margin-bottom", bioHeight + "px");
          }
          $this.toggleClass("is-open");
        }

        $this.find(".team-card__read-more").click(toggleCard);
        $this.children(".team-card__image").click(toggleCard);
        $this.find(".team-card__bio>button.close").click(toggleCard);
      });
    },
  };
})(Drupal, jQuery, once);
